// The VibeBuddy mark v4: the living dot.
// The green presence dot IS the product — your agent's heartbeat, personified.
// A mint pixel blob with bright eyes and one hopeful spark, on a dark tile.
// Drawn procedurally at any size from a 16x16 grid.

export function brandGrid() {
  const g = Array.from({ length: 16 }, () => Array(16).fill(null));
  const set = (x, y, c) => {
    if (x >= 0 && x < 16 && y >= 0 && y < 16) g[y][x] = c;
  };
  const mint = '#35d07f';
  const mintHi = '#63e6a5';
  const mintLo = '#1d9e75';
  const ink = '#10131c';
  const glint = '#dfe8ff';
  const spark = '#f5c542';
  const sparkHi = '#fff3c4';

  // no tile, no frame — the dot floats free on whatever's behind it
  // the dot: a rounded mint blob, ten pixels of pure alive
  const rows = {
    3: [5, 10], 4: [4, 11], 5: [3, 12], 6: [3, 12], 7: [3, 12],
    8: [3, 12], 9: [3, 12], 10: [3, 12], 11: [4, 11], 12: [5, 10],
  };
  for (const [yy, [x0, x1]] of Object.entries(rows)) for (let x = x0; x <= x1; x++) set(x, Number(yy), mint);

  // light falls from the top-left, weight settles bottom-right
  set(5, 3, mintHi); set(6, 3, mintHi); set(4, 4, mintHi); set(5, 4, mintHi); set(3, 5, mintHi); set(4, 5, mintHi);
  for (let x = 5; x <= 10; x++) set(x, 12, mintLo);
  set(11, 11, mintLo); set(10, 11, mintLo); set(12, 10, mintLo); set(12, 9, mintLo); set(11, 4, mintLo);

  // wide-set eyes with a glint — the buddy face rule
  set(5, 6, ink); set(6, 6, ink); set(5, 7, ink); set(6, 7, ink);
  set(9, 6, ink); set(10, 6, ink); set(9, 7, ink); set(10, 7, ink);
  set(5, 6, glint); set(9, 6, glint);

  // a small honest smile
  set(7, 9, ink); set(8, 9, ink);

  // one hopeful spark, top-right — the run just finished
  set(13, 1, spark); set(13, 3, spark); set(12, 2, spark); set(14, 2, spark);
  set(13, 2, sparkHi);

  return g;
}

export function drawBrandMark(ctx, size, { bg = null } = {}) {
  const c = size / 16;
  ctx.clearRect(0, 0, size, size);
  if (bg) {
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, size, size);
  }
  const g = brandGrid();
  for (let y = 0; y < 16; y++)
    for (let x = 0; x < 16; x++) {
      if (!g[y][x]) continue;
      ctx.fillStyle = g[y][x];
      ctx.fillRect(Math.round(x * c), Math.round(y * c), Math.ceil(c), Math.ceil(c));
    }
}
